module.exports = __webpack_public_path__ + "img/paw-white.2b009453.png";